var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "#CACBD6",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.59 8.41a.885.885 0 0 1 0-.679l1.53-3.074c.27-.497-.134-1.085-.674-1.085h-2.16v2.803c0 .317-.27.588-.585.588a.597.597 0 0 1-.585-.588V2.713a1.81 1.81 0 0 0-1.8-1.809H3.15c-.135 0-.225.09-.225.226v8.59c0 .136.09.227.225.227h5.625c.316 0 .54.271.54.543 0 .316-.27.587-.585.587H6.3c0 .814.675 1.492 1.485 1.492h6.66c.54 0 .9-.588.676-1.085L13.59 8.41ZM.9 0C.405 0 0 .407 0 .904v15.192c0 .497.405.904.9.904s.9-.407.9-.904V.904A.905.905 0 0 0 .9 0Z"
  })));
};

export default SvgFlag;